import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
    name: 'currencyTransform',
})
export class CurrencyTransformPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) {
    }

    transform(value: any, args: any): any {

        let currency = ' ';
        if (args) {
            currency = args.toLowerCase();
        }

        const val = this.decimalPipe.transform(value, '1.2-2');


        if (currency === 'eur') {
            return val + ' €';
        }

        if (currency === 'usd') {
            return val + ' $';
        }

        return val + ' ' + currency.toUpperCase();
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/pipes/currency-transform.pipe.ts